import { Box, Paper, Typography } from "@mui/material";
import type { DynamicForm, FormSubmit } from "api";
import { type Control } from "react-hook-form";
import { DynamicFormInput } from "./DynamicFormInput";
import { DynamicFormStepHeading } from "./DynamicFormStepHeading";
import { TextBlocksRenderer } from "../TextBlocksRenderer";

type Props = {
  contactInfo: DynamicForm["contact"];
  control: Control<FormSubmit, unknown, FormSubmit>;
};

export const DynamicFormContactInfo = (props: Props) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <DynamicFormStepHeading>
          {props.contactInfo?.title || "Contact Information"}
        </DynamicFormStepHeading>
        {props.contactInfo?.text && (
          <TextBlocksRenderer content={props.contactInfo.text} />
        )}
      </Box>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          p: 2,
        }}
      >
        {props.contactInfo?.firstName && (
          <Box>
            <Typography component="h5" variant="h5">
              {props.contactInfo.firstNameLabel ?? "First Name"}
            </Typography>
            <DynamicFormInput
              control={props.control}
              name="contactInfo.firstName"
              required={props.contactInfo.firstNameRequired}
            />
          </Box>
        )}
        {props.contactInfo?.lastName && (
          <Box>
            <Typography component="h5" variant="h5">
              {props.contactInfo.lastNameLabel ?? "Last Name"}
            </Typography>
            <DynamicFormInput
              control={props.control}
              name="contactInfo.lastName"
              required={props.contactInfo.lastNameRequired}
            />
          </Box>
        )}
        {props.contactInfo?.email && (
          <Box>
            <Typography component="h5" variant="h5">
              {props.contactInfo.emailLabel ?? "Email"}
            </Typography>
            <DynamicFormInput
              control={props.control}
              name="contactInfo.email"
              required={props.contactInfo.emailRequired}
              pattern={/^[A-Z][A-Z0-9._%+-]*@[A-Z0-9.-]+\.[A-Z]{2,}$/i}
              patternMessage="Must be a valid email"
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};
